module.exports = __webpack_public_path__ + "img/logo_dark_1.ef879794.png";